<template>
  <div class="container col-lg-12">
    <div class="row ligne">
      <div class="justify-between footer">
        <div>
          <router-link class="no-underline font-bold hover:underline" to="/changelog" exact>
            <span class="changelogTitle">Changelog</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Footer',
  computed: mapGetters([
    'isLogged'
  ])
}
</script>
<style scoped>
  .changelogTitle {
    float: right;
    font-size: 14px;
    color:green;
    margin-right: 35px;
  }

  .footer {
    width: 80%;
  }

  .container {
    position: absolute;
    bottom: 0;
  }

  .ligne {
    color: #1B8EA6;
    border-top-style: solid;
    border-top-width: 1px;
  }

</style>
